import dayjs from 'dayjs'
const config = {
    'searchList': {
        'searchTxt': [
            {
                'name': '签署方式',
                'value': 'pushType',
                'type': 'select',
                'unfold': true,
                'optionNum': 'SRM_SUPPLIER_DELEGATE_TYPE',
                'span': 4
            },
            {
                'name': '供应商签署状态',
                'value': 'supplierPushStatusList',
                'type': 'select',
                'multiple': true,
                'unfold': true,
                'optionNum': 'SRM_SUPPLIER_DELEGATE_STATUS',
                'span': 4
            },
            {
                'name': '司机签署状态',
                'value': 'driverPushStatusList',
                'type': 'select',
                'multiple': true,
                'unfold': true,
                'optionNum': 'SRM_SUPPLIER_DELEGATE_STATUS',
                'span': 4
            },
            {
                'name': '签署人',
                'value': 'stamperName',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '签署手机号码',
                'value': 'stamperMobile',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '供应商',
                'value': 'supplierCode',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'ALL', 'value': '全部' },
                    { 'prop': 'supplierCode', 'value': '供应商编码' },
                    { 'prop': 'supplierName', 'value': '供应商名称' }
                ],
                'tableConfig': [
                    { 'prop': 'supplierCode', 'value': '供应商编码' },
                    { 'prop': 'supplierName', 'value': '供应商名称' },
                    { 'prop': 'supplierTypeName', 'value': '供应商类型' },
                    { 'prop': 'propertyNatureName', 'value': '主体性质' },
                    { 'prop': 'businessTypeName', 'value': '业务类型' }
                ],
                'advanceUrl': '/supplier/getBlackSupplierInfoResponseBySupplierCodeAndSupplierName',
                'prefix': '/api-srm-web',
                'type': 'advance',
                'cbParams': ['supplierCode#supplierCode'],
                'span': 3
            },
            {
                name: '司机',
                value: 'driverCode',
                type: 'advance',
                unfold: true,
                advanceConfig: [
                    { prop: 'driverName', value: '名称' },
                    { prop: 'driverCode', value: '编号' },
                    { prop: 'phoneNo', value: '手机号' },
                    { prop: 'idCard', value: '身份证' },
                ],
                tableConfig: [
                    { prop: 'driverCode', value: '编号' },
                    { prop: 'driverName', value: '名称' },
                    { prop: 'phoneNo', value: '手机号' },
                    { prop: 'idCard', value: '身份证' },
                ],
                advanceUrl: '/supplier/supplierDriverInfos',
                prefix: '/api-srm-web',
                method: 'post',
                cbParams: ['driverCode'],
                span: 3
            },
            {
                'name': '供应商签署批次号',
                'value': 'signNumber',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '签署文件编号',
                'value': 'signFileNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '时间范围',
                'value': 'timeRange',
                'type': 'time',
                'startPlaceholder': '开始时间',
                'endPlaceholder': '结束时间',
                'unfold': true,
                'span': 6,
                'pickerOptions': {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(6, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(30, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近二个月',
                        onClick(picker) {
                            const start = dayjs().startOf('day').subtract(60, 'd').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        ],
        'unfoldState': false,
        'advancedBtn': true,
        'resetBtn': true
    },
    'table': {
        'leftOperation': true,
        'leftWidth': 80,
        'selectBtn': true,
        'height': 'calc(100vh - 206px)',
        'columns': [
            {
                'label': '序号',
                'prop': 'id',
                'width': '80px'
            },
            {
                'label': '委派函记录流水号',
                'prop': 'contractNo',
                'width': '200px'
            },
            {
                'label': '供应商签署批次号',
                'prop': 'signNumber',
                'width': '200px'
            },
            {
                'label': '记录创建时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '供应商编码',
                'prop': 'supplierCode',
                'width': '150px'
            },
            {
                'label': '供应商名称',
                'prop': 'supplierName',
                'width': '150px'
            },
            {
                'label': '司机名称',
                'prop': 'driverName',
                extraTags: [
                    { name: '已注销', color: '#f2f2f2' },
                ],
                'width': '110px'
            },
            {
                'label': '司机编码',
                'prop': 'driverCode',
                'width': '150px'
            },
            {
                'label': '司机手机号',
                'prop': '_phoneNo',
                extraTags: [
                    { name: '已注销', color: '#f2f2f2' },
                ],
                'width': '150px'
            },
            {
                'label': '签署方式',
                'prop': 'pushType',
                type: 'select',
                optionNum: 'SRM_SUPPLIER_DELEGATE_TYPE',
                options: [],
                'width': '150px'
            },
            {
                'label': '供应商签署状态',
                'prop': 'supplierPushStatus',
                type: 'select',
                optionNum: 'SRM_SUPPLIER_DELEGATE_STATUS',
                options: [],
                'width': '150px'
            },
            {
                'label': '司机签署状态',
                'prop': 'driverPushStatus',
                type: 'select',
                optionNum: 'SRM_SUPPLIER_DELEGATE_STATUS',
                options: [],
                'width': '150px'
            },
        ],
        'action': [
            {
                'type': 'text',
                'label': '签署详情',
                'size': 'small',
                'event': 'detail'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
export default config;